export const EDIT_COLLECTION_REQUESTED = 'EDIT_COLLECTION_REQUESTED';
export const EDIT_COLLECTION_SUCCEEDED = 'EDIT_COLLECTION_SUCCEEDED';
export const GET_COLLECTION_REQUESTED = 'GET_COLLECTION_REQUESTED';
export const GET_COLLECTION_SUCCEEDED = 'GET_COLLECTION_SUCCEEDED';
export const DELETE_COLLECTION_REQUESTED = 'DELETE_COLLECTION_REQUESTED';
export const DELETE_COLLECTION_SUCCEEDED = 'DELETE_COLLECTION_SUCCEEDED';
export const ATTACH_PRODUCT_TO_COLLECTION_REQUESTED = 'ATTACH_PRODUCT_TO_COLLECTION_REQUESTED';
export const ATTACH_PRODUCT_TO_COLLECTION_SUCCEEDED = 'ATTACH_PRODUCT_TO_COLLECTION_SUCCEEDED';
export const IMPORT_PRODUCT_FROM_FILE_REQUESTED = 'IMPORT_PRODUCT_FROM_FILE_REQUESTED';
export const IMPORT_PRODUCT_FROM_FILE_COMPLETED = 'IMPORT_PRODUCT_FROM_FILE_COMPLETED';
export const IMPORT_PRODUCT_FROM_FILE_SUCCEEDED = 'IMPORT_PRODUCT_FROM_FILE_SUCCEEDED';
export const IMPORT_PRODUCT_FROM_FILE_FAILED = 'IMPORT_PRODUCT_FROM_FILE_FAILED';
export const ATTACH_PRODUCT_TO_COLLECTION_FAILED = 'ATTACH_PRODUCT_TO_COLLECTION_FAILED';
export const SEND_COLLECTION_CONSIGNMENT_AGREEMENT_REQUESTED = 'SEND_COLLECTION_CONSIGNMENT_AGREEMENT_REQUESTED';
export const SEND_COLLECTION_CONSIGNMENT_AGREEMENT_SUCCEEDED = 'SEND_COLLECTION_CONSIGNMENT_AGREEMENT_SUCCEEDED';
export const RESPOND_COLLECTION_SUCCEEDED = 'RESPOND_COLLECTION_SUCCEEDED';
export const RESPOND_COLLECTION_REQUESTED = 'RESPOND_COLLECTION_REQUESTED';
export const SEND_COLLECTION_TO_SHOOT_REQUESTED = 'SEND_COLLECTION_TO_SHOOT_REQUESTED';
export const SEND_COLLECTION_TO_SHOOT_SUCCEEDED = 'SEND_COLLECTION_TO_SHOOT_SUCCEEDED';
export const SEND_COLLECTION_TO_WAREHOUSE_REQUESTED = 'SEND_COLLECTION_TO_WAREHOUSE_REQUESTED';
export const SEND_COLLECTION_TO_WAREHOUSE_SUCCEEDED = 'SEND_COLLECTION_TO_WAREHOUSE_SUCCEEDED';
export const SEND_COLLECTION_PICKUP_CONFIRMATION_REQUESTED = 'SEND_COLLECTION_PICKUP_CONFIRMATION_REQUESTED';
export const SEND_COLLECTION_PICKUP_CONFIRMATION_SUCCEEDED = 'SEND_COLLECTION_PICKUP_CONFIRMATION_SUCCEEDED';
export const GET_IMPORT_HISTORIES_REQUESTED = 'GET_IMPORT_HISTORIES_REQUESTED';
export const GET_IMPORT_HISTORIES_SUCCEEDED = 'GET_IMPORT_HISTORIES_SUCCEEDED';

